import { RoutePath } from "#src/utils/route";
import { WorkflowTaskRoutePath } from "../..";

export const WorkflowTaskAddFormSubmissionRoutePath =
  WorkflowTaskRoutePath.concat(
    new RoutePath<string, "formSchemaId">({
      path: "/form-submission/add",
      title: "Add Form Submission",
    })
  );
